import { apiService } from "../../services/apiService";

const Api = apiService.injectEndpoints({
    endpoints: builder => ({
        updateCredentials: builder.mutation({
            query: (body) => ({
                url: `smtp/updateSmtpCredentials`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getSmtpCredentials: builder.query({
            query: () => ({
                url: 'smtp/getSmtpCredentials'
            }),
            providesTags: ["FlexzaiDialerAdmin"],
        }),
        updateCallCredentials: builder.mutation({
            query: (body) => ({
                url: `callSettings/updateCallCredentials`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getCallCredentials: builder.query({
            query: () => ({
                url: 'callSettings/getCallCredentials'
            }),
            providesTags: ["FlexzaiDialerAdmin"],
        }),
    })
})

export const { useUpdateCredentialsMutation, useGetSmtpCredentialsQuery, useGetCallCredentialsQuery, useUpdateCallCredentialsMutation } = Api
